import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const ticketPrioritySchema = z.object({
    color: z.string().nullish(),
    created_at: zDayJs.nullish(),
    name: z.string().nullish(),
    priority: z.number().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const ticketPrioritiesSchema = z.array(ticketPrioritySchema)

export const paginatedTicketPrioritiesResponseSchema = z.object({
    data: ticketPrioritiesSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveTicketPriorityResponseSchema = z.object({
    data: ticketPrioritySchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

const validation_requiredMessage = "You can't leave this empty."

export const ticketPriorityFormSchema = z.object({
    title: z
        .string({
            error: validation_requiredMessage,
        })
        .min(1, {
            message: validation_requiredMessage,
        }),
    color: z
        .string({
            error: validation_requiredMessage,
        })
        .min(1, {
            message: validation_requiredMessage,
        }),
})

export type PaginatedTicketPrioritiesResponse = z.infer<
    typeof paginatedTicketPrioritiesResponseSchema
>
export type TicketPriorityForm = z.infer<typeof ticketPriorityFormSchema>
export type TicketPriority = z.infer<typeof ticketPrioritySchema>
export type TicketPriorities = z.infer<typeof ticketPrioritiesSchema>
export type RetrieveTicketPriorityResponse = z.infer<typeof retrieveTicketPriorityResponseSchema>
